import AxiosInstance from "../instance";
import {returnValidResponse} from "../utils";


const getTextCompletionResult = async (data: any) => {
    const response = await AxiosInstance.getInstance().post("/text-completion", data);
    return response;
};

const getEngines = async () => {
    const response = await AxiosInstance.getInstance().get("/text-completion/engines");
    return returnValidResponse(response);
};

export {getTextCompletionResult, getEngines};


// WEBPACK FOOTER //
// ./src/api/models/TextCompletion.ts